import { withFormik } from "formik";
import { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { compose, withHandlers, withState } from "recompose";
import { Button, Form, Grid, Icon, Message, Modal } from "semantic-ui-react";
import AvailableFields from "./AvailableFields";
import { UnitsApiService } from "../../../../api";

const ContextFormModal = ({
  availableFields,
  handleChange,
  handleSubmit,
  isSubmitting,
  onCheckAllChange,
  onClose,
  open,
  validationErrors,
  values,
  setFieldValue,
}) => {
  return (
    <Modal
      as="form"
      closeIcon
      onClose={onClose}
      onSubmit={handleSubmit}
      open={open}
    >
      <Modal.Content scrolling>
        <Form as="div" error={validationErrors !== undefined}>
          <Grid>
            <Grid.Column computer={8} width={16}>
              <Form.Input
                autoFocus
                label="Nazwa"
                name="name"
                onChange={handleChange}
                required
                value={values["name"]}
              />
              {get(validationErrors, "name") && (
                <Message content={get(validationErrors, "spId")} error />
              )}
              <Form.Input
                label="Sp Id"
                name="spId"
                onChange={handleChange}
                required
                type="number"
                value={values["spId"]}
              />
              {get(validationErrors, "spId") && (
                <Message content={get(validationErrors, "spId")} error />
              )}
              <Form.Input
                label="Hasło"
                name="password"
                onChange={handleChange}
                required
                value={values["password"]}
              />
              {get(validationErrors, "password") && (
                <Message content={get(validationErrors, "spId")} error />
              )}
              <Form.Checkbox
                checked={values["showStats"]}
                label="Wyświetlaj statystyki spraw"
                onChange={() =>
                  setFieldValue("showStats", !values["showStats"])
                }
                value={values["showStats"]}
                name="showStats"
              />
              <Form.Input
                label="Notification dispatcher api key"
                name="notificationsApiKey"
                onChange={handleChange}
                value={values["notificationsApiKey"]}
              />
              {get(validationErrors, "notificationsApiKey") && (
                <Message content={get(validationErrors, "spId")} error />
              )}
              <Form.TextArea
                label="Szablon wiadomości SMS"
                name="notificationMessageTemplate"
                onChange={handleChange}
                value={values["notificationMessageTemplate"]}
              />
              {get(validationErrors, "notificationMessageTemplate") && (
                <Message content={get(validationErrors, "spId")} error />
              )}
            </Grid.Column>
            <Grid.Column computer={8} width={16}>
              <AvailableFields
                availableFields={availableFields}
                checkedFields={values["availableFields"]}
                onCheckAllChange={onCheckAllChange}
              />
            </Grid.Column>
          </Grid>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          disabled={isSubmitting}
          icon
          labelPosition="left"
          loading={isSubmitting}
          positive
          type="submit"
        >
          <Icon name="save" /> Zapisz
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

ContextFormModal.propTypes = {
  availableFields: PropTypes.array,
  onCheckAllChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  open: PropTypes.bool,
  validationErrors: PropTypes.object,
  values: PropTypes.object.isRequired,
};

const enhance = compose(
  withState("validationErrors", "setValidationErrors", undefined),
  withFormik({
    enableReinitialize: true,
    handleSubmit: async (values, { props, resetForm, setSubmitting }) => {
      try {
        const newContext = props.context
          ? await UnitsApiService.saveUnit(values, props.context.id)
          : await UnitsApiService.saveUnit(values);
        await props.onSave(newContext);
        props.setValidationErrors();
        resetForm();
        props.onClose();
      } catch (error) {
        props.setValidationErrors(error.validationErrors);
      } finally {
        setSubmitting(false);
      }
    },
    mapPropsToValues: ({ context }) => ({
      availableFields: get(context, "availableFields", []),
      name: get(context, "name", ""),
      notificationsApiKey: get(context, "notificationsApiKey", ""),
      notificationMessageTemplate: get(
        context,
        "notificationMessageTemplate",
        ""
      ),
      password: get(context, "password", ""),
      spId: get(context, "spId", ""),
      showStats: get(context, "showStats", false),
    }),
  }),
  withHandlers({
    onCheckAllChange: ({ availableFields, setFieldValue, values }) => () => {
      const allFieldsChecked =
        values["availableFields"].length === availableFields.length;
      setFieldValue(
        "availableFields",
        allFieldsChecked ? [] : availableFields.map(({ name }) => name)
      );
    },
    onClose: ({ onClose, resetForm, setValidationErrors }) => () => {
      setValidationErrors();
      resetForm();
      onClose();
    },
  })
);

export { ContextFormModal, enhance };
export default enhance(ContextFormModal);



// WEBPACK FOOTER //
// ./src/containers/contexts/components/context-form-modal/ContextFormModal.js